import gql from 'graphql-tag';

const query = gql`
  query ValidateDietSettings($request: DietJoInputType!) {
    me {
      validateDietSettings(settings: $request) {
        code
        messages
        details {
          fieldName
          messages
        }
      }
    }
  }
`;

export default query;
